/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TicketUser } from '../models/ticket-user';
import { TicketStatus } from '../models/ticket-status';
import { TicketPriority } from '../models/ticket-priority';
import { Ticket } from '../models/ticket';
import { TicketSearchResult } from '../models/ticket-search-result';
import { TicketSearchRequest } from '../models/ticket-search-request';
import { NewTicket } from '../models/new-ticket';
import { TicketNote } from '../models/ticket-note';
@Injectable({
  providedIn: 'root',
})
class TicketService extends __BaseService {
  static readonly TicketGetAssignableUsersPath = '/api/Ticket/GetAssignableUsers/{customerId}';
  static readonly TicketGetTicketStatusesPath = '/api/Ticket/GetTicketStatuses';
  static readonly TicketGetTicketPrioritiesPath = '/api/Ticket/GetTicketPriorities';
  static readonly TicketGetMyTicketsPath = '/api/Ticket/GetMyTickets/{customerId}/{includeUnassigned}';
  static readonly TicketGetMyClosedTicketsPath = '/api/Ticket/GetMyClosedTickets/{customerId}/{includeUnassigned}';
  static readonly TicketGetCustomerTicketsPath = '/api/Ticket/GetCustomerTickets/{customerId}';
  static readonly TicketSearchTicketsPath = '/api/Ticket/SearchTickets';
  static readonly TicketCreateTicketPath = '/api/Ticket/CreateTicket/{customerId}';
  static readonly TicketUpdateTicketPath = '/api/Ticket/UpdateTicket/{customerId}';
  static readonly TicketUpdateTicketStatusPath = '/api/Ticket/UpdateTicketStatus/{ticketId}/{statusId}';
  static readonly TicketAcknowledgeTicketPath = '/api/Ticket/AcknowledgeTicket/{ticketId}';
  static readonly TicketCreateTicketNotePath = '/api/Ticket/CreateTicketNote/{ticketId}';
  static readonly TicketUpdateTicketNotePath = '/api/Ticket/UpdateTicketNote/{customerId}/{ticketId}';
  static readonly TicketDeleteTicketNotePath = '/api/Ticket/DeleteTicketNote/{ticketNoteId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  TicketGetAssignableUsersResponse(customerId: number): __Observable<__StrictHttpResponse<Array<TicketUser>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Ticket/GetAssignableUsers/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TicketUser>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  TicketGetAssignableUsers(customerId: number): __Observable<Array<TicketUser>> {
    return this.TicketGetAssignableUsersResponse(customerId).pipe(
      __map(_r => _r.body as Array<TicketUser>)
    );
  }
  TicketGetTicketStatusesResponse(): __Observable<__StrictHttpResponse<Array<TicketStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Ticket/GetTicketStatuses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TicketStatus>>;
      })
    );
  }  TicketGetTicketStatuses(): __Observable<Array<TicketStatus>> {
    return this.TicketGetTicketStatusesResponse().pipe(
      __map(_r => _r.body as Array<TicketStatus>)
    );
  }
  TicketGetTicketPrioritiesResponse(): __Observable<__StrictHttpResponse<Array<TicketPriority>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Ticket/GetTicketPriorities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TicketPriority>>;
      })
    );
  }  TicketGetTicketPriorities(): __Observable<Array<TicketPriority>> {
    return this.TicketGetTicketPrioritiesResponse().pipe(
      __map(_r => _r.body as Array<TicketPriority>)
    );
  }

  /**
   * @param params The `TicketService.TicketGetMyTicketsParams` containing the following parameters:
   *
   * - `includeUnassigned`:
   *
   * - `customerId`:
   */
  TicketGetMyTicketsResponse(params: TicketService.TicketGetMyTicketsParams): __Observable<__StrictHttpResponse<Array<Ticket>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Ticket/GetMyTickets/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.includeUnassigned))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Ticket>>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketGetMyTicketsParams` containing the following parameters:
   *
   * - `includeUnassigned`:
   *
   * - `customerId`:
   */
  TicketGetMyTickets(params: TicketService.TicketGetMyTicketsParams): __Observable<Array<Ticket>> {
    return this.TicketGetMyTicketsResponse(params).pipe(
      __map(_r => _r.body as Array<Ticket>)
    );
  }

  /**
   * @param params The `TicketService.TicketGetMyClosedTicketsParams` containing the following parameters:
   *
   * - `includeUnassigned`:
   *
   * - `customerId`:
   */
  TicketGetMyClosedTicketsResponse(params: TicketService.TicketGetMyClosedTicketsParams): __Observable<__StrictHttpResponse<Array<Ticket>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Ticket/GetMyClosedTickets/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.includeUnassigned))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Ticket>>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketGetMyClosedTicketsParams` containing the following parameters:
   *
   * - `includeUnassigned`:
   *
   * - `customerId`:
   */
  TicketGetMyClosedTickets(params: TicketService.TicketGetMyClosedTicketsParams): __Observable<Array<Ticket>> {
    return this.TicketGetMyClosedTicketsResponse(params).pipe(
      __map(_r => _r.body as Array<Ticket>)
    );
  }

  /**
   * @param customerId undefined
   */
  TicketGetCustomerTicketsResponse(customerId: number): __Observable<__StrictHttpResponse<Array<Ticket>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Ticket/GetCustomerTickets/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Ticket>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  TicketGetCustomerTickets(customerId: number): __Observable<Array<Ticket>> {
    return this.TicketGetCustomerTicketsResponse(customerId).pipe(
      __map(_r => _r.body as Array<Ticket>)
    );
  }

  /**
   * @param request undefined
   */
  TicketSearchTicketsResponse(request: TicketSearchRequest): __Observable<__StrictHttpResponse<TicketSearchResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/SearchTickets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TicketSearchResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  TicketSearchTickets(request: TicketSearchRequest): __Observable<TicketSearchResult> {
    return this.TicketSearchTicketsResponse(request).pipe(
      __map(_r => _r.body as TicketSearchResult)
    );
  }

  /**
   * @param params The `TicketService.TicketCreateTicketParams` containing the following parameters:
   *
   * - `ticket`:
   *
   * - `customerId`:
   */
  TicketCreateTicketResponse(params: TicketService.TicketCreateTicketParams): __Observable<__StrictHttpResponse<Ticket>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.ticket;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/CreateTicket/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Ticket>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketCreateTicketParams` containing the following parameters:
   *
   * - `ticket`:
   *
   * - `customerId`:
   */
  TicketCreateTicket(params: TicketService.TicketCreateTicketParams): __Observable<Ticket> {
    return this.TicketCreateTicketResponse(params).pipe(
      __map(_r => _r.body as Ticket)
    );
  }

  /**
   * @param params The `TicketService.TicketUpdateTicketParams` containing the following parameters:
   *
   * - `updateTicket`:
   *
   * - `customerId`:
   */
  TicketUpdateTicketResponse(params: TicketService.TicketUpdateTicketParams): __Observable<__StrictHttpResponse<Ticket>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateTicket;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/UpdateTicket/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Ticket>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketUpdateTicketParams` containing the following parameters:
   *
   * - `updateTicket`:
   *
   * - `customerId`:
   */
  TicketUpdateTicket(params: TicketService.TicketUpdateTicketParams): __Observable<Ticket> {
    return this.TicketUpdateTicketResponse(params).pipe(
      __map(_r => _r.body as Ticket)
    );
  }

  /**
   * @param params The `TicketService.TicketUpdateTicketStatusParams` containing the following parameters:
   *
   * - `ticketId`:
   *
   * - `statusId`:
   */
  TicketUpdateTicketStatusResponse(params: TicketService.TicketUpdateTicketStatusParams): __Observable<__StrictHttpResponse<Ticket>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/UpdateTicketStatus/${encodeURIComponent(String(params.ticketId))}/${encodeURIComponent(String(params.statusId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Ticket>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketUpdateTicketStatusParams` containing the following parameters:
   *
   * - `ticketId`:
   *
   * - `statusId`:
   */
  TicketUpdateTicketStatus(params: TicketService.TicketUpdateTicketStatusParams): __Observable<Ticket> {
    return this.TicketUpdateTicketStatusResponse(params).pipe(
      __map(_r => _r.body as Ticket)
    );
  }

  /**
   * @param ticketId undefined
   */
  TicketAcknowledgeTicketResponse(ticketId: number): __Observable<__StrictHttpResponse<Ticket>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/AcknowledgeTicket/${encodeURIComponent(String(ticketId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Ticket>;
      })
    );
  }
  /**
   * @param ticketId undefined
   */
  TicketAcknowledgeTicket(ticketId: number): __Observable<Ticket> {
    return this.TicketAcknowledgeTicketResponse(ticketId).pipe(
      __map(_r => _r.body as Ticket)
    );
  }

  /**
   * @param params The `TicketService.TicketCreateTicketNoteParams` containing the following parameters:
   *
   * - `ticketId`:
   *
   * - `note`:
   */
  TicketCreateTicketNoteResponse(params: TicketService.TicketCreateTicketNoteParams): __Observable<__StrictHttpResponse<TicketNote>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.note != null) __params = __params.set('note', params.note.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/CreateTicketNote/${encodeURIComponent(String(params.ticketId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TicketNote>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketCreateTicketNoteParams` containing the following parameters:
   *
   * - `ticketId`:
   *
   * - `note`:
   */
  TicketCreateTicketNote(params: TicketService.TicketCreateTicketNoteParams): __Observable<TicketNote> {
    return this.TicketCreateTicketNoteResponse(params).pipe(
      __map(_r => _r.body as TicketNote)
    );
  }

  /**
   * @param params The `TicketService.TicketUpdateTicketNoteParams` containing the following parameters:
   *
   * - `ticketId`:
   *
   * - `customerId`:
   *
   * - `ticketNoteId`:
   *
   * - `notes`:
   */
  TicketUpdateTicketNoteResponse(params: TicketService.TicketUpdateTicketNoteParams): __Observable<__StrictHttpResponse<TicketNote>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    if (params.ticketNoteId != null) __params = __params.set('ticketNoteId', params.ticketNoteId.toString());
    if (params.notes != null) __params = __params.set('notes', params.notes.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Ticket/UpdateTicketNote/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.ticketId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TicketNote>;
      })
    );
  }
  /**
   * @param params The `TicketService.TicketUpdateTicketNoteParams` containing the following parameters:
   *
   * - `ticketId`:
   *
   * - `customerId`:
   *
   * - `ticketNoteId`:
   *
   * - `notes`:
   */
  TicketUpdateTicketNote(params: TicketService.TicketUpdateTicketNoteParams): __Observable<TicketNote> {
    return this.TicketUpdateTicketNoteResponse(params).pipe(
      __map(_r => _r.body as TicketNote)
    );
  }

  /**
   * @param ticketNoteId undefined
   */
  TicketDeleteTicketNoteResponse(ticketNoteId: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Ticket/DeleteTicketNote/${encodeURIComponent(String(ticketNoteId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ticketNoteId undefined
   */
  TicketDeleteTicketNote(ticketNoteId: number): __Observable<Blob> {
    return this.TicketDeleteTicketNoteResponse(ticketNoteId).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module TicketService {

  /**
   * Parameters for TicketGetMyTickets
   */
  export interface TicketGetMyTicketsParams {
    includeUnassigned: boolean;
    customerId: number;
  }

  /**
   * Parameters for TicketGetMyClosedTickets
   */
  export interface TicketGetMyClosedTicketsParams {
    includeUnassigned: boolean;
    customerId: number;
  }

  /**
   * Parameters for TicketCreateTicket
   */
  export interface TicketCreateTicketParams {
    ticket: NewTicket;
    customerId: number;
  }

  /**
   * Parameters for TicketUpdateTicket
   */
  export interface TicketUpdateTicketParams {
    updateTicket: Ticket;
    customerId: number;
  }

  /**
   * Parameters for TicketUpdateTicketStatus
   */
  export interface TicketUpdateTicketStatusParams {
    ticketId: number;
    statusId: number;
  }

  /**
   * Parameters for TicketCreateTicketNote
   */
  export interface TicketCreateTicketNoteParams {
    ticketId: number;
    note?: null | string;
  }

  /**
   * Parameters for TicketUpdateTicketNote
   */
  export interface TicketUpdateTicketNoteParams {
    ticketId: string;
    customerId: number;
    ticketNoteId?: number;
    notes?: null | string;
  }
}

export { TicketService }
